import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetSingleLenderQuery } from "../../store";
import { ViewCard } from "../../components";

const keyProps = {
  Name: "name",
  Email: "email",
  "Phone Number": "phone",
  Role: "role",
  "Created At": "created_at",
  "Updated At": "updated_at",
  Applicant: "applicant",
  // Location: "location",
};

const ViewLender = () => {
  const { id } = useParams();

  const [modalShow, setModalShow] = useState(false);
  const { isLoading, isSuccess, error, data } = useGetSingleLenderQuery(id);
  console.log(data);
  return (
    <ViewCard
      title={"User Details"}
      data={data?.user}
      setModalShow={setModalShow}
      keyProps={keyProps}
      isImage={true}
      image_url={data?.user?.image}
      reducerProps={{ error, isLoading, isSuccess }}
    >
      {/* <EditModel show={modalShow} onHide={() => setModalShow(false)} />
      {!modalShow && <ToastContainer />} */}
    </ViewCard>
  );
};

export default ViewLender;
